var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action, makeObservable, computed } from 'mobx';
import { CustomFieldType } from './models';
var CustomFieldsStore = /** @class */ (function () {
    function CustomFieldsStore() {
        Object.defineProperty(this, "fields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        makeObservable(this);
        window.$CustomFieldsStore = this;
    }
    Object.defineProperty(CustomFieldsStore.prototype, "isValid", {
        get: function () {
            var invalidProperties = this.fields.filter(function (f) { return f.isMandatory && !f.value; });
            return invalidProperties.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomFieldsStore.prototype, "getFieldValues", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var values = {};
            this.fields.forEach(function (f) { return values[f.name] = f.value; });
            return values;
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "setFieldValues", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (values) {
            this.fields.forEach(function (f) { return f.value = ''; });
            var _loop_1 = function (key) {
                if (values.hasOwnProperty(key)) {
                    var field = this_1.fields.find(function (f) { return f.name == key; });
                    if (field) {
                        field.value = values[key];
                    }
                }
            };
            var this_1 = this;
            for (var key in values) {
                _loop_1(key);
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldName", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, name) {
            if (!name)
                return;
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            var existingField = this.fields.find(function (f) { return f.name === name; });
            if (fieldToUpdate && !existingField) {
                fieldToUpdate.name = name;
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldLabel", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, label) {
            if (!label)
                label = '';
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                fieldToUpdate.defaultLabel = label;
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, type) {
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                fieldToUpdate.type = type;
                if (type !== CustomFieldType.List && type !== CustomFieldType.Radio)
                    fieldToUpdate.options = undefined;
                else if (!fieldToUpdate.options)
                    fieldToUpdate.options = [];
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldWidth", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, width) {
            if (width <= 0 || width > 12)
                return;
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                fieldToUpdate.width = width;
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldMandatory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, value) {
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                fieldToUpdate.isMandatory = value;
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, value) {
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                fieldToUpdate.value = value;
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldOptionName", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, name, newName) {
            var _a, _b;
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                var optionToUpdate = (_a = fieldToUpdate.options) === null || _a === void 0 ? void 0 : _a.find(function (o) { return o.name === name; });
                var existingOption = (_b = fieldToUpdate.options) === null || _b === void 0 ? void 0 : _b.find(function (o) { return o.name === newName; });
                if (optionToUpdate && !existingOption) {
                    optionToUpdate.name = newName;
                }
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "updateFieldOptionValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, name, newValue) {
            var _a, _b;
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                var optionToUpdate = (_a = fieldToUpdate.options) === null || _a === void 0 ? void 0 : _a.find(function (o) { return o.name === name; });
                var existingOption = (_b = fieldToUpdate.options) === null || _b === void 0 ? void 0 : _b.find(function (o) { return o.value === newValue; });
                if (optionToUpdate && !existingOption) {
                    optionToUpdate.value = newValue;
                }
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "addFieldOption", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field) {
            var _a;
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                if (!fieldToUpdate.options)
                    fieldToUpdate.options = [];
                var newOptionName_1 = 'Field' + (fieldToUpdate.options.length + 1);
                var existingOption = (_a = fieldToUpdate.options) === null || _a === void 0 ? void 0 : _a.find(function (o) { return o.name === newOptionName_1; });
                if (!existingOption) {
                    fieldToUpdate.options.push({
                        name: newOptionName_1,
                        value: ''
                    });
                }
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "removeFieldOption", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field, optionName) {
            var fieldToUpdate = this.fields.find(function (f) { return f.name === field.name; });
            if (fieldToUpdate) {
                if (!fieldToUpdate.options)
                    return;
                var index = fieldToUpdate.options.findIndex(function (o) { return o.name === optionName; });
                if (index !== -1) {
                    fieldToUpdate.options.splice(index, 1);
                }
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "addField", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field) {
            field.name = 'Field' + this.fields.length;
            var existingField = this.fields.find(function (f) { return f.name === field.name; });
            if (!existingField) {
                this.fields.push(field);
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "removeField", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field) {
            var index = this.fields.findIndex(function (f) { return f.name === field.name; });
            if (index !== -1) {
                this.fields.splice(index, 1);
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "moveFieldUp", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field) {
            var index = this.fields.findIndex(function (f) { return f.name === field.name; });
            if (index > 0) {
                this.fields.splice(index, 1);
                this.fields.splice(index - 1, 0, field);
            }
        }
    });
    Object.defineProperty(CustomFieldsStore.prototype, "moveFieldDown", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field) {
            var index = this.fields.findIndex(function (f) { return f.name === field.name; });
            if (index !== -1 && index < this.fields.length - 1) {
                this.fields.splice(index, 1);
                this.fields.splice(index + 1, 0, field);
            }
        }
    });
    __decorate([
        observable
    ], CustomFieldsStore.prototype, "fields", void 0);
    __decorate([
        computed
    ], CustomFieldsStore.prototype, "isValid", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "setFieldValues", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldName", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldLabel", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldType", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldWidth", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldMandatory", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldValue", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldOptionName", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "updateFieldOptionValue", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "addFieldOption", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "removeFieldOption", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "addField", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "removeField", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "moveFieldUp", null);
    __decorate([
        action
    ], CustomFieldsStore.prototype, "moveFieldDown", null);
    return CustomFieldsStore;
}());
export default CustomFieldsStore;
